module.exports = __webpack_public_path__ + "static/img/header_banner.53f6a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/CustomersInfo/header_banner.png
// module id = CAnV
// module chunks = 19